<template>
  <div class="detail-wrap">
    <el-form ref="service" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}分类
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>
     
            <!-- 工单信息 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first">
                  <!-- <b>主信息</b> -->
                  </div>
                  <table class="table-detail">
						<tbody>
							<tr>
                <th>
									<em class="f-red">*</em>
									分类名称
								</th>
								<td>
                  <el-input type="text" autocomplete="off" v-model="service.serviceTme" clearable />
								</td>
                <th>
									<em class="f-red">*</em>
									分类编码
								</th>
								<td>
                  <el-input type="text" autocomplete="off" v-model="service.serviceTyName" clearable />
								</td>              						
								<th>
                  <em class="f-red">*</em>
                 类型
                  </th>
								<td>
                  <el-form-item  :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="service.parentId" >
                      <el-option  label="产品" :value="1" />
                      <el-option  label="配件" :value="2" />
                       <el-option  label="耗材" :value="3" />
                    </el-select>
                  </el-form-item>
                </td>							
                <th>
                  <em class="f-red">*</em>
                  上级分类
                  </th>
								<td>
                  <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="service.businessType" >
                      <el-option  label="ID1" :value="1" />
                      <el-option  label="ID2" :value="2" />
                      <el-option  label="ID3" :value="3" />
                      <el-option  label="ID4" :value="4" />
           
                    </el-select>
                  </el-form-item>
                </td>
               
              
							</tr>
<div style="height:10px"></div>
              <tr>  
                    <th>
									<em class="f-red">*</em>
									完工条码数
								</th>
								<td>
                  <el-input type="number" autocomplete="off" v-model="service.serviceTypeName" clearable />
								</td>         
                   <th>
									<em class="f-red">*</em>
									是否在自建中显示
								</th>
								<td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                      <el-select v-model="service.parentId3">
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                      </el-select>
                    </el-form-item>
								</td>

								<!-- <th>
                  <em class="f-red">*</em>
                  状态
                  </th>
								<td>
                  <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="service.stat" >
                      <el-option  label="正常" :value="0" />
                      <el-option  label="禁用" :value="1" />
                    </el-select>
                  </el-form-item>
                </td> -->
              </tr>
           
              <div style="height:10px"></div>
              
						<tr></tr>
							<tr>
								<th>创建人</th>
								<td>{{ tenant.createBy }}</td>
								<th>创建时间</th>
								<td>{{ tenant.createDate }}</td>
								<th>修改人</th>
								<td>{{ tenant.modifyBy }}</td>
								<th>修改时间</th>
								<td>{{ tenant.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
              
              </div>

          
            </div>
        
      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
      @confirm="confirmCategory" />
  </div>
</template>
<script>
  import {
    initVxeTable
  } from '@/const/crud/admin/table';
  import Tinymce from '@/components/Tinymce';
  import request from "@/router/axios";
  // 城市三级联动
  import {
    regionData,
    CodeToText,
    TextToCode
  } from "element-china-area-data";
  export default {
    name: 'edit',
    props: {
      _dataId: [String, Number]
    },
    components: {
      Tinymce,
    },
    data() {
      return {

        // 以上表单信息
        img_b: "",
        upload_btn: false, // 是否隐藏上传图片按钮
        radio: '1',
        showEdit: false,
        op: [{
          value: '0',
          label: '禁止'
        }, {
          value: '1',
          label: '启用'
        }],
        op2: [{
          value: '0',
          label: '工单'
        }, {
          value: '1',
          label: '考核单'
        }],
        options3: [{
            value: 'model',
            label: '是'
          },
          {
            value: 'machine',
            label: '否'
          }
        ],
        valuetype: 'model',
        textarea: '',
        //  value1: true,
        value2: false,
        value3: true,
        activeName: 'first',
        dialog: {
          one: false,
        },
        lan: 'zh_CN',
        isEdit: false,
        tabIndex: 'first',
        dataId: '',
        // 基本信息
        service: {
          pic: '',
          pic1: '',
        },
        tenant: {
          status: 0,
          tenantAttachmentDTOs: []
        },
        showProductCategoryDialog: false,
        languageDTOs: [],
        upload_img: [],
        dialogImageUrl: '',
        //地址选择
        selectemp: {},
        selectedOptions: [],
        options: regionData,
      };
    },
    computed: {
      // enabled: {}
    },
    created() {
      if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
      // console.log(this.tenant,"tenant的值");
    },
    mounted() {

      this.getData();
      console.log(this.tenant, "tenant的值");
      console.log(this._dataId, "_dataId的值");
    },
    methods: {
      // 上传成功
      handleSuccess(response, file, res) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn = true;

        console.log(response,"上传成功后response")
        console.log(file,"上传成功后file")
        console.log(res,"上传成功后res")
      },
      handleRemove(response, file, res) {
        // 删除成功后，显示上传按钮
        this.upload_btn = false;
          console.log(response,"删除成功后response")
        console.log(file,"删除成功后file")
        console.log(res,"删除成功后res")
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 以上表单事件
      confirmSaleConfig(rows) {
        if (rows.length > 0) {
          const $grid = this.$refs.configGrid;
          const tableData3 = $grid.getTableData().fullData;
          const map = {};
          tableData.forEach(function (item) {
            map[item.configId] = 1;
          });
          var items = [];
          rows.forEach((row, index) => {
            const item = {
              configId: row.id,
              configName: row.configName
            };
            if (index == 0 && tableData3.length == 0) {
              item.defaults = true;
            }
            if (!map[item.configId]) {
              items.push(item);
            }
          });
          this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
        }
      },
      // 上传成功
      
      // 第一个  表格
      formatter(row, column) {
        return row.address;
      },
      submitUpload() {
        this.$refs.upload.submit()
      },

      getData() {
        if (this.dataId && !isNaN(this.dataId)) {
          this.isEdit = true;
          request({
            url: '/admin/fwpttenant/get',
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            console.log(response);
            this.tenant = response.data.objx || {};
          })
        } else {
          // this.enabled = true;
        }
      },
      saveData() {
        this.$refs.service.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              var url = HXFW_PREFIX + (this.isEdit ? `/fault/code/update` : `/fault/code/save`);
              this.$http({
                url: url,
                method: `post`,
                data: this.tenant,
                isLoading: true,
                success: res => {
                  this.$message({
                    message: res.content,
                    type: 'success',
                    duration: 500,
                    onClose: t => {
                      if (this.isEdit) {
                        this.$baseReload();
                      } else {
                        this.$baseReload({
                          updateParam: {
                            _dataId: res.objx
                          }
                        });
                      }
                    }
                  });
                }
              });
            });
          }
        });
      },
      confirmCategory(rows) {
        if (rows.length > 0) {
          let row = rows[0];
          this.tenant.itemCatId = row.id;
          this.tenant.itemCatName = row.categoryName;
          this.tenant.itemCatCode = row.categoryCode;
        }
      },
      // 地址三级联动
      handleChange() {
        var loc = "";
        for (let i = 0; i < this.selectedOptions.length; i++) {
          loc += CodeToText[this.selectedOptions[i]] + "-";
        }
        this.infoForm.province = loc.split("-")[0];
        this.infoForm.city = loc.split("-")[1];
        console.log(loc.split("-"), this.infoForm.province, this.infoForm.city)
      },
    },
  };

</script>
<style lang="scss" scoped>
  .pic_total {
    margin-left: 45px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    ::v-deep.el-upload--picture-card {
      margin-top: 20px;
      margin-left: 30%;
      width: 88px !important;
      height: 88px !important;
      line-height: 88px !important;
    }

    ::v-deep.el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
      width: 88px !important;
      height: 88px !important;
      padding: 0 !important;
    }

    ::v-deep.el-upload-list .el-upload-list__item {
      display: inline-block;
      width: 88px !important;
      height: 88px !important;
      margin-right: 0px !important;
      border-radius: 2px;
      padding: 0px !important;
      border-color: #e8e8e8;
      margin-top: 20px;
      margin-bottom: 10px;
      margin-left: 30%;
    }

    .pic_total_items {
      width: 21%;
      border: 1px solid #e3e3e3;
      height: 200px;
      margin-right: 20px;
    margin-bottom: 20px;
      
      .pic_p{
            display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-left: 25px;
      p{
          font-size: 12px;
          font-weight: 400;
          width: 110px;
          text-align: right;
          color: #606266;
          display: inline-block;
          word-wrap: break-word;
          white-space: normal;
        }
        ::v-deep.el-select>.el-input {
    display: block;
     margin-top: 5px; 
}
}
      
      }

      .form_pic {
        width: 40%;
      }

      .form_ename {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 80%;
        // margin-left: 10%;
        // margin-top: -25px;

        span {
          font-size: 12px;
          font-weight: 400;
          width: 115px;
              line-height: 28px;
          text-align: right;
          color: #606266;
          display: inline-block;
          word-wrap: break-word;
          white-space: normal;
        }
      }



    
  }

</style>
